import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DynamicCSS from './DynamicCSS';
import ClientProvider from './client';
export default createDemo(import.meta.url, DynamicCSS, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/how-to-customize/demos/dynamic-css/DynamicCSS.tsx",
    "fileName": "DynamicCSS.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { alpha, styled } from '@mui/material/styles';\nimport Slider from '@mui/material/Slider';\nimport type { SliderProps } from '@mui/material/Slider';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Switch from '@mui/material/Switch';\n\ninterface StyledSliderProps extends SliderProps {\n  success?: boolean;\n}\n\nconst StyledSlider = styled(Slider, {\n  shouldForwardProp: (prop) => prop !== 'success',\n})<StyledSliderProps>(({ theme }) => ({\n  width: 300,\n  variants: [\n    {\n      props: ({ success }) => success,\n      style: {\n        color: theme.palette.success.main,\n        '& .MuiSlider-thumb': {\n          [`&:hover, &.Mui-focusVisible`]: {\n            boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.success.main, 0.16)}`,\n          },\n          [`&.Mui-active`]: {\n            boxShadow: `0px 0px 0px 14px ${alpha(theme.palette.success.main, 0.16)}`,\n          },\n        },\n      },\n    },\n  ],\n}));\n\nexport default function DynamicCSS() {\n  const [success, setSuccess] = React.useState(false);\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setSuccess(event.target.checked);\n  };\n\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <React.Fragment>\n      <FormControlLabel\n        control={\n          <Switch\n            checked={success}\n            onChange={handleChange}\n            color=\"primary\"\n            value=\"dynamic-class-name\"\n          />\n        }\n        label=\"Success\"\n      />\n      <StyledSlider success={success} defaultValue={30} sx={{ mt: 1 }} />\n    </React.Fragment>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 57,
        "focusedLines": 14,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { alpha, styled } from '@mui/material/styles';\nimport Slider from '@mui/material/Slider';\nimport type { SliderProps } from '@mui/material/Slider';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Switch from '@mui/material/Switch';\n\ninterface StyledSliderProps extends SliderProps {\n  success?: boolean;\n}\n\nconst StyledSlider = styled(Slider, {\n  shouldForwardProp: (prop) => prop !== 'success',\n})<StyledSliderProps>(({ theme }) => ({\n  width: 300,\n  variants: [\n    {\n      props: ({ success }) => success,\n      style: {\n        color: theme.palette.success.main,\n        '& .MuiSlider-thumb': {\n          [`&:hover, &.Mui-focusVisible`]: {\n            boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.success.main, 0.16)}`,\n          },\n          [`&.Mui-active`]: {\n            boxShadow: `0px 0px 0px 14px ${alpha(theme.palette.success.main, 0.16)}`,\n          },\n        },\n      },\n    },\n  ],\n}));\n\nexport default function DynamicCSS() {\n  const [success, setSuccess] = React.useState(false);\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setSuccess(event.target.checked);\n  };\n\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <React.Fragment>\n      <FormControlLabel\n        control={\n          <Switch\n            checked={success}\n            onChange={handleChange}\n            color=\"primary\"\n            value=\"dynamic-class-name\"\n          />\n        }\n        label=\"Success\"\n      />\n      <StyledSlider success={success} defaultValue={30} sx={{ mt: 1 }} />\n    </React.Fragment>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControlLabel"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "checked"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "success"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 49
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "dynamic-class-name",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 50
            },
            "          />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 51
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 52
            },
            [
              "        ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 53
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 54
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "StyledSlider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "success"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "success"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "mt"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 55
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 57,
    "focusedLines": 14,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Slider",
      "@mui/material/FormControlLabel",
      "@mui/material/Switch"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
